/** Transaction conflict ve geçici hatalarda yeniden dener. */
export async function withRetry(fn, maxAttempts = 3) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;
      const retryable =
        err?.code === 'failed-precondition' ||
        err?.code === 'aborted' ||
        err?.code === 'unavailable';
      if (!retryable || attempt === maxAttempts - 1) throw err;
      await new Promise((r) => setTimeout(r, 100 * 2 ** attempt));
    }
  }
  throw lastError;
}
